import React, { Fragment, Component } from 'react';

// Component
import SingleSelectItem from './SingleSelectItem/SingleSelectItem';
import MultiSelectItem from './MultiSelectItem/MultiSelectItem';
import OpenEndedItem from './OpenEndedItem/OpenEndedItem';
import ScaleSliderItem from "./ScaleSliderItem/ScaleSliderItem";
import PlaceholderItem from './PlaceholderItem/PlaceholderItem';
import RankItem from './RankItem/RankItem';
import ImageItem from './ImageItem/ImageItem';
import Section from '../Section/Section';

import './SurveyItem.css';

class SurveyItem extends Component {

    componentDidUpdate(nextProps) {
     if(nextProps == this.props){
            return true
        } else {
            return false
        }
    }
    render() {
        const { configuration, pageInstrumentConfiguration } = this.props;
        const { scales } = pageInstrumentConfiguration;
        const scaleKey = configuration.scaleKey;
        const scaleResponse = scales[scaleKey];

        var itemType = null;

        if (scaleResponse && scaleResponse.hasOwnProperty('itemType')) {
            itemType = scaleResponse.itemType;
        } else {
            itemType = null;
        }

        return (
            <Fragment>
                { itemType === '1' ?  <SingleSelectItem key={configuration.key} {...this.props}/>
                    : itemType === '101' ?  <SingleSelectItem key={configuration.key} {...this.props}/>
                    : itemType === '2' || itemType === '102' ? <MultiSelectItem key={configuration.key} {...this.props}/>
                    : itemType === '-1' ? <OpenEndedItem key={configuration.key} {...this.props} />
                    : itemType === '3' ? <RankItem key={configuration.key} {...this.props} />
                    : itemType === '4' ? <ScaleSliderItem key={configuration.key} {...this.props} />
                    : itemType === '5' ? <ImageItem key={configuration.key} {...this.props} />
                    : itemType === '0' || itemType === null ? <PlaceholderItem key={configuration.key}  {...this.props} />
                    : null}
            </Fragment>
        )
    }
}

export default SurveyItem;